"use client";

import { use, useEffect } from "react";
import { useLoader, usePathname } from "@rangojs/router/client";
import { RecentlyViewedLoader } from "../loaders/recently-viewed.jsx";

export function RecentlyViewed() {
  const pathname = usePathname();
  const { data, load } = useLoader(RecentlyViewedLoader);
  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
  if (!data.content) return null;
  return use(data.content);
}
